// Detect if a value looks like a RA FileInput value
const isFileLike = (value: any) =>
  value instanceof File || (value && typeof value === "object" && ("rawFile" in value || value instanceof Blob));

type BuildFormDataOptions = {
  /**
   * Optional mapping between RA field names and actual backend field names.
   * Example: { json: "file" } -> field "json" in the form becomes "file" in FormData
   */
  fieldNameMapping?: Record<string, string>;
};

export const buildFormData = (data: any, options: BuildFormDataOptions = {}) => {
  const formData = new FormData();
  const mapping = options.fieldNameMapping || {};

  Object.entries(data || {}).forEach(([key, value]) => {
    const fieldName = mapping[key] || key;

    if (value == null) {
      return;
    }

    // Case 1: array of files (FileInput with multiple, or multiple images)
    if (Array.isArray(value) && value.length > 0 && isFileLike(value[0])) {
      value.forEach((item) => {
        const file = item.rawFile ?? item;
        formData.append(fieldName, file as Blob);
      });
      return;
    }

    // Case 2: single file
    if (isFileLike(value)) {
      const file = (value as any).rawFile ?? value;
      formData.append(fieldName, file as Blob);
      return;
    }

    // Case 3: non-file value
    if (typeof value === "object") {
      // Generic choice: send objects/arrays as JSON strings
      formData.append(fieldName, JSON.stringify(value));
    } else {
      formData.append(fieldName, String(value));
    }
  });

  return formData;
};
